export default __webpack_public_path__ + "static/media/Reverse_Primer.0fc245dd.svg";